import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
import { usePageView } from '../../hooks/usePageView';
import './Careers.css';

function JobCard({ job, c }) {
  return (
    <div className="careers-card">
      <div className="job-header">
        <h2 className="job-title">{job.title}</h2>
        <div className="job-meta">
          <span className="job-tag">
            📍 {job.count}
            {c.countUnit}
          </span>
          {job.regions.length > 1 && <span className="job-tag">🏢 {c.nationwide}</span>}
        </div>
      </div>

      <div className="job-regions">
        <span className="region-label">{c.regionLabel}</span>
        <div className="region-tags">
          {job.regions.map((r) => (
            <span key={r} className="region-tag">
              {r}
            </span>
          ))}
        </div>
      </div>

      <div className="job-section">
        <h3>{c.responsibilities}</h3>
        <ol className="job-list">
          {job.responsibilities.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </div>

      <div className="job-section">
        <h3>{c.requirements}</h3>
        <ol className="job-list">
          {job.requirements.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </div>

      <div className="job-apply">
        <p>
          {c.applyPrefix}
          <a href={`mailto:${job.email}`}>{job.email}</a>
        </p>
        <p className="apply-note">{c.applyNote}</p>
      </div>
    </div>
  );
}

export default function Careers() {
  usePageView('careers');
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useLanguage();
  const c = t.careers;

  useEffect(() => {
    fetch('/api/careers')
      .then((r) => r.json())
      .then((data) => setJobs(Array.isArray(data) ? data : []))
      .catch(() => setJobs([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="careers-page">
      <Helmet>
        <title>招贤纳士 - 首嘉/深圳瀚阳</title>
        <meta
          name="description"
          content="首嘉/深圳瀚阳诚招物流销售、运营等岗位人才，加入我们共同发展。"
        />
        <meta property="og:title" content="招贤纳士 - 首嘉/深圳瀚阳" />
        <meta property="og:description" content="首嘉/深圳瀚阳诚招物流销售、运营等岗位人才，加入我们共同发展。" />
        <meta property="og:url" content="https://www.sz-showjoy.com/careers" />
        <meta name="keywords" content="物流招聘,物流销售,货运运营,深圳物流工作,首嘉/深圳瀚阳招聘" />
        <link rel="canonical" href="https://www.sz-showjoy.com/careers" />
      </Helmet>
      <div className="page-header">
        <div className="container">
          <h1>{c.pageTitle}</h1>
          <p>{c.pageSubtitle}</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          {loading ? (
            <p style={{ textAlign: 'center', color: '#6b7280' }}>{c.loading}</p>
          ) : jobs.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#6b7280' }}>{c.noJobs}</p>
          ) : (
            <div className="jobs-list">
              {jobs.map((job) => (
                <JobCard key={job.uuid} job={job} c={c} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
